import { Brain } from "lucide-react";
import { FaTwitter, FaGithub, FaLinkedin, FaYoutube } from "react-icons/fa";

export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-8 h-8 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
                <Brain className="text-white text-sm" />
              </div>
              <h4 className="text-lg font-bold">La IA Fácil</h4>
            </div>
            <p className="text-gray-400 text-sm">
              Tu plataforma integral para aprender, experimentar y mantenerte actualizado en inteligencia artificial.
            </p>
          </div>

          <div>
            <h5 className="font-semibold mb-4">Plataforma</h5>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <button 
                  onClick={() => scrollToSection('tools')}
                  className="hover:text-white transition-colors"
                >
                  Herramientas IA
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('blog')}
                  className="hover:text-white transition-colors"
                >
                  Blog
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('notebooks')}
                  className="hover:text-white transition-colors"
                >
                  Notebooks
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('papers')}
                  className="hover:text-white transition-colors"
                >
                  Papers
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="font-semibold mb-4">Cuenta</h5>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="/api/login" className="hover:text-white transition-colors">Iniciar Sesión</a></li>
              <li><a href="/api/login" className="hover:text-white transition-colors">Registrarse</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Planes Premium</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Mi Perfil</a></li>
            </ul>
          </div>

          <div>
            <h5 className="font-semibold mb-4">Soporte</h5>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#" className="hover:text-white transition-colors">Centro de Ayuda</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Contacto</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Términos de Uso</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Privacidad</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 La IA Fácil. Todos los derechos reservados.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-400 hover:text-white transition-colors">
              <FaTwitter />
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors">
              <FaGithub />
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors">
              <FaLinkedin />
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors">
              <FaYoutube />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
